import Vue from 'vue';
import StopCampaignModalComponent from '@/components/Modals/StopCampaignModal.vue';

/**
 * StopCampaignModal Utility Class
 * Custom modal untuk stop campaign dengan 3 button options
 * Terinspirasi dari AgreementModal pattern
 * 
 * Usage:
 * const result = await StopCampaignModal.fire();
 * 
 * Result:
 * {
 *   action: 'stop-now' | 'stop-after' | 'cancel',
 *   stop_after_billing_period: 'T' | 'F' | null
 * }
 */
class StopCampaignModal {
    /**
     * Main method to show stop campaign modal
     * @returns {Promise} Promise that resolves with user's choice
     */
    static async fire() {
        // Return Promise yang akan resolve berdasarkan user action
        return new Promise((resolve, reject) => {
            // Create Vue instance untuk modal component
            const ModalComponent = Vue.extend(StopCampaignModalComponent);
            
            // Create instance
            const modalInstance = new ModalComponent({
                propsData: {
                    show: false // Initial false, akan diubah di nextTick
                }
            });

            // Setup event handlers
            modalInstance.$on('stop-now', () => {
                // Close modal
                modalInstance.internalShow = false;
                setTimeout(() => {
                    modalInstance.$destroy();
                    if (modalInstance.$el && modalInstance.$el.parentNode) {
                        modalInstance.$el.parentNode.removeChild(modalInstance.$el);
                    }
                }, 300);

                // Resolve dengan stop immediate
                resolve({ 
                    action: 'stop-now',
                    stop_after_billing_period: 'F'
                });
            });

            modalInstance.$on('stop-after', () => {
                // Close modal
                modalInstance.internalShow = false;
                setTimeout(() => {
                    modalInstance.$destroy();
                    if (modalInstance.$el && modalInstance.$el.parentNode) {
                        modalInstance.$el.parentNode.removeChild(modalInstance.$el);
                    }
                }, 300);

                // Resolve dengan stop after period
                resolve({ 
                    action: 'stop-after',
                    stop_after_billing_period: 'T'
                });
            });

            modalInstance.$on('cancel', () => {
                // Close modal
                modalInstance.internalShow = false;
                setTimeout(() => {
                    modalInstance.$destroy();
                    if (modalInstance.$el && modalInstance.$el.parentNode) {
                        modalInstance.$el.parentNode.removeChild(modalInstance.$el);
                    }
                }, 300);

                // Resolve dengan cancel (atau bisa reject)
                resolve({ 
                    action: 'cancel',
                    stop_after_billing_period: null
                });
            });

            // Mount component to body
            modalInstance.$mount();
            document.body.appendChild(modalInstance.$el);

            // Tunggu nextTick, baru set z-index dan trigger animation
            Vue.nextTick(() => {
                modalInstance.internalShow = true;
                modalInstance.$forceUpdate();
            });
        });
    }
}

export default StopCampaignModal;
